import type { RouteRecordRaw } from 'vue-router'

const tradingCertificatesRoutes: RouteRecordRaw[] = [
  {
    path: '/trading-certificates',
    name: 'trading-certificates.index',
    component: () =>
      import('@/modules/certificates/trading-certificates/views/TradingCertificatesIndex.vue'),
    meta: {
      pageTitle: 'Trading certificates',
      breadcrumbs: ['Trading certificates']
    }
  },
  {
    path: '/trading-certificates/:id',
    name: 'trading-certificates.show',
    component: () =>
      import('@/modules/certificates/trading-certificates/views/TradingCertificatesShow.vue'),
    meta: {
      pageTitle: 'Trading certificates',
      breadcrumbs: ['Trading certificates']
    }
  },
  {
    path: '/trading-certificates/create',
    name: 'trading-certificates.create',
    component: () =>
      import('@/modules/certificates/trading-certificates/views/TradingCertificatesEdit.vue'),
    meta: {
      pageTitle: 'Trading certificates',
      breadcrumbs: ['Trading certificates']
    }
  },
  {
    path: '/trading-certificates/:id/edit',
    name: 'trading-certificates.edit',
    component: () =>
      import('@/modules/certificates/trading-certificates/views/TradingCertificatesEdit.vue'),
    meta: {
      pageTitle: 'Trading certificates',
      breadcrumbs: ['Trading certificates']
    }
  }
]

export default tradingCertificatesRoutes
